import { render, staticRenderFns } from "./ForgeTagsSelector.vue?vue&type=template&id=7f165172&scoped=true&lang=html"
import script from "./ForgeTagsSelector.vue?vue&type=script&lang=js"
export * from "./ForgeTagsSelector.vue?vue&type=script&lang=js"
import style0 from "./ForgeTagsSelector.vue?vue&type=style&index=0&id=7f165172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f165172",
  null
  
)

export default component.exports